import { useMemo } from "react";

import { assert, processNodeSubtree, type DesignerNodeData } from "@skilitics/nautilus-core-designer-data";

import { useGetManifest } from "../../state/index.ts";
import { useMigrateNode } from "./useMigrateNode.ts";

export const useMigrateSubtree = () => {
  const migrateNode = useMigrateNode();
  const getManifest = useGetManifest();
  return useMemo(
    () => (startNode: DesignerNodeData) =>
      processNodeSubtree(startNode, (node: DesignerNodeData, context): DesignerNodeData => {
        if (getManifest(node.typeId)?.version === node.version) return node;
        const migrated = migrateNode(node, context);
        assert(migrated, `No migration for ${node.typeId} ${node.version}.`);
        return migrated;
      }),
    [getManifest, migrateNode],
  );
};

export type MigrateSubtree = ReturnType<typeof useMigrateSubtree>;
